<template>
    <authenticated-layout>
        <v-card class="pa-2 sm:pa-6">
            <h1 class="text-xl font-bold pt-4 pl-4">Twoje Oferty</h1>

            <div
                class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2 mt-8 mb-4"
            >
                <div v-for="table in tables" :key="table.title">
                    <h2 class="text-center bg-gray-50 pa-2 rounded-md">
                        {{ table.title }}
                    </h2>

                    <table>
                        <tr>
                            <th
                                v-for="(header, index) in table.headers"
                                :key="`header-index-${index}-${header}`"
                                class="text-left"
                            >
                                {{ header }}
                            </th>
                        </tr>

                        <tr
                            v-for="(row, index) in table.rows"
                            :key="`row-index-${index}-${row}`"
                        >
                            <td
                                v-for="(item, index) in row"
                                :key="`item-index-${index}-${item}`"
                                class="text-left"
                            >
                                {{ item }}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <p class="my-6 text-sm">
                Sprzedaż poniżej określonych stawek nie jest dozwolona.
                <br />Sprzedaż powyżej poziomów rozliczana 50% Doradca, 50%
                Nova.
            </p>
        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated";

export default {
    components: {
        AuthenticatedLayout,
    },
    data: () => ({
        tables: [
            {
                title: "Komplet zestaw 5kWh",
                headers: ["Urządzenie", "Nazwa", "Ilość"],
                rows: [
                    ["BackupBOX 3-fazy", "PowerBOX", "1"],
                    ["Luna2000-5kWh moduł AKU", "LiFePO4", "1"],
                    ["Moduł zarządzania", "Luna2000_DCDC", "1"],
                    ["Licznik energii", "DTSU666-H_250", "1"],
                    ["CENA NETTO BEZ BACKUPBOX", "", "23060zł"],
                    ["PROWIZJA DORADCY BEZ BACKUPBOX", "", "831zł"],
                    ["CENA NETTO Z BACKUPBOX", "", "27940zł"],
                    ["PROWIZJA DORADCY Z BACKUPBOX", "", "1007zł"],
                ],
            },
            {
                title: "Komplet zestaw 10kWh",
                headers: ["Urządzenie", "Nazwa", "Ilość"],
                rows: [
                    ["BackupBOX 3-fazy", "PowerBOX", "1"],
                    ["Luna2000-5kWh moduł AKU", "LiFePO4", "2"],
                    ["Moduł zarządzania", "Luna2000_DCDC", "1"],
                    ["Licznik energii", "DTSU666-H_250", "1"],
                    ["CENA NETTO BEZ BACKUPBOX", "", "35969zł"],
                    ["PROWIZJA DORADCY BEZ BACKUPBOX", "", "1297zł"],
                    ["CENA NETTO Z BACKUPBOX", "", "40849zł"],
                    ["PROWIZJA DORADCY Z BACKUPBOX", "", "1473zł"],
                ],
            },
            {
                title: "Komplet zestaw 15kWh",
                headers: ["Urządzenie", "Nazwa", "Ilość"],
                rows: [
                    ["BackupBOX 3-fazy", "PowerBOX", "1"],
                    ["Luna2000-5kWh moduł AKU", "LiFePO4", "3"],
                    ["Moduł zarządzania", "Luna2000_DCDC", "1"],
                    ["Licznik energii", "DTSU666-H_250", "1"],
                    ["CENA NETTO BEZ BACKUPBOX", "", "48878zł"],
                    ["PROWIZJA DORADCY BEZ BACKUPBOX", "", "1762zł"],
                    ["CENA NETTO Z BACKUPBOX", "", "53758zł"],
                    ["PROWIZJA DORADCY Z BACKUPBOX", "", "1938zł"],
                ],
            },
        ],
    }),
};
</script>

<style scoped>
table {
    width: 100%;
    table-layout: fixed;
    font-size: 12px;
}

@media screen and (max-width: 1024px) {
    table {
        width: auto;
    }
}

th {
    padding: 10px 0px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    box-sizing: border-box;
    padding-left: 10px;
    border-bottom: 1px solid #aaa;
}

td {
    text-align: left;
    box-sizing: border-box;
    padding: 5px 0px;
    padding-left: 10px;
    border-bottom: 1px solid #ccc;
}
</style>
